import { defineStore } from 'pinia';
import type PlayerSpy from '@/types/PlayerSpy.ts'

export const useSpyStore = defineStore('spyStore', {
    state: () => ({
        spies: new Map<number, PlayerSpy>()
    }),
    getters: {
        findSpyById: (state) => (id: number): PlayerSpy | undefined => {
            return state.spies.get(id);
        }
    },
    actions: {
        updateSpyById(id: number, data: PlayerSpy) {
            //console.log('updateSpyById', id, data);
            const existing = this.spies.get(id);
            if (existing) {
                // Merge changes into existing item
                Object.assign(existing, data);
                this.spies.set(id, existing);
            } else {
                this.spies.set(id, data);
            }
        }
    },
});
